import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container margin-top-70" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createVNode("h3", { class: "headline centered margin-bottom-45" }, [
    /*#__PURE__*/_createTextVNode(" Most Visited Places "),
    /*#__PURE__*/_createVNode("span", null, "Discover top-rated local businesses")
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "col-md-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarouselItem = _resolveComponent("CarouselItem")
  const _component_Slide = _resolveComponent("Slide")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Pagination = _resolveComponent("Pagination")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (this.places)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_Carousel, {
              "items-to-show": this.places.length < 3 ? 1 : 3,
              currentSlide: 0,
              "wrap-around": true
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation),
                _createVNode(_component_Pagination)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.places, (placeItem) => {
                  return (_openBlock(), _createBlock(_component_Slide, { key: placeItem }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CarouselItem, { place: placeItem }, null, 8, ["place"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["items-to-show"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}